module.exports = __webpack_public_path__ + "static/img/icon.cb8d59b9.png";